// Bootstrap Icons (public/assets/vendor/bootstrap-icons) for the menu names
// that come from the backend. Matched without case; unknown names get a
// neutral icon, so new menus still look right.
const ICONS = {
  // Sidebar (level 1)
  "mill details": "bi-building",
  "data feeding": "bi-pencil-square",
  "upload excel": "bi-file-earmark-spreadsheet",
  "data approval": "bi-patch-check",
  "nsws json": "bi-send",
  report: "bi-file-earmark-pdf",
  "season data": "bi-calendar3",
  "access user right": "bi-people",

  // Pages (level 2)
  "lab data": "bi-eyedropper",
  chemical: "bi-droplet",
  "godown domestic": "bi-truck",
  "godown export import": "bi-globe2",
  "godown stock": "bi-box-seam",
  "cane office": "bi-briefcase",
  "cane dues data": "bi-cash-coin",
  "create json": "bi-filetype-json",
  "monthly data feeding": "bi-file-earmark-pdf",
  "user control": "bi-person-gear",
  "menu right": "bi-shield-lock",
  "password change": "bi-key",
};

export const menuIcon = (name) =>
  ICONS[String(name || "").trim().toLowerCase()] || "bi-grid";
